class ServiceResponseExeption extends Error {
    constructor(message) {
      super(message);
      this.name = "ServiceResponseExeption";
    }
}

export default ServiceResponseExeption;